import React, { useEffect, useState } from "react";

const STORAGE_KEY = "thesiscribeBetaNotice";

const BetaNoticeBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const hasAcknowledged = window.localStorage.getItem(STORAGE_KEY) === "true";
    setVisible(!hasAcknowledged);
  }, []);

  const handleAcknowledge = () => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, "true");
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6 bg-black/70">
      <div className="w-full max-w-xl rounded-xl bg-white/95 p-6 text-slate-900 shadow-2xl dark:bg-slate-900/95 dark:text-slate-100">
        <p className="text-sm font-semibold uppercase tracking-wide text-purple-600 dark:text-purple-300">
          Beta Access Agreement
        </p>
        <h2 className="mt-2 text-xl font-bold">Private Testing Build</h2>
        <p className="mt-3 text-sm leading-relaxed text-slate-600 dark:text-slate-300">
          ThesiScribe + Organizer is currently in a restricted beta. This link is intended
          only for invited classmates. Please respect the testing guidelines and do not
          share the URL, screenshots, or data outside the pilot group without written
          permission.
        </p>
        <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">
          By continuing you acknowledge these terms and agree to provide feedback directly
          to the study team.
        </p>
        <button
          type="button"
          onClick={handleAcknowledge}
          className="mt-5 inline-flex w-full items-center justify-center rounded-lg bg-purple-600 px-4 py-2 text-sm font-semibold text-white shadow hover:bg-purple-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-400"
        >
          I understand and agree
        </button>
      </div>
    </div>
  );
};

export default BetaNoticeBanner;
